import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SongList } from '../components/SongList';
import { ArrowLeft, ArrowRight, Mic2, Ticket, Star } from 'lucide-react';
export function RecordsPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-512" data-mp="3bejiuak50pgs">
      <Header data-id="element-513" data-mp="31ig9okqvbqkc" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-514" data-mp="31hx0ptj74cig">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-515" data-mp="31h56am1c4ktr">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-516" data-mp="36ikq6ars0lak">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-517" data-mp="2sk4mksp7nawn" />
            Back to Home
          </a>

          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-518" data-mp="2wlg4sd5r8tut">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-519" data-mp="qrq7e1e1wkjx">
              TwiceBourne Records
            </h1>
            <p className="text-xl text-slate-300" data-id="element-520" data-mp="upw9ux7uwdz1">
              Amplifying voices and creating timeless music. Our record label is
              dedicated to discovering and nurturing exceptional talent.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-521" data-mp="2eci08mi0k7i4">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8" data-id="element-522" data-mp="2eem5p8vk9eki">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-523" data-mp="1lnaup3k56hnd">
                <Mic2 className="w-7 h-7" data-id="element-524" data-mp="1gqaz5mkx4xai" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-525" data-mp="1vm0fb43fag7b">
                Music Production
              </h3>
              <p className="text-slate-300 text-lg leading-relaxed" data-id="element-526" data-mp="1qmxho4prvc9d">
                We produce music and connect various artists with distribution
                networks to maximize their audience reach across all platforms.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8" data-id="element-527" data-mp="324owzmrnigi2">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-528" data-mp="3e3lu0g3bbpjv">
                <Ticket className="w-7 h-7" data-id="element-529" data-mp="3j51cq1i0pjz3" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-530" data-mp="3o3co4gnyo2jf">
                Concert Hosting
              </h3>
              <p className="text-slate-300 text-lg leading-relaxed" data-id="element-531" data-mp="2qg3yc9gxg7bm">
                We host concerts with artist entourages, providing high-quality
                backstage services and seamless event management for artists.
              </p>
            </div>
          </div>

          <div className="text-center bg-white/5 backdrop-blur rounded-3xl border border-slate-700/50 p-12 max-w-4xl mx-auto" data-id="element-532" data-mp="354gvvavnxy88">
            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-533" data-mp="27nrxjr5x9e3l">
              Ready to amplify your voice?
            </h2>
            <p className="text-slate-300 mb-8 text-lg" data-id="element-534" data-mp="2clthsff33jgn">
              Join our growing roster of talented artists and let us help you
              reach your full potential.
            </p>
            <button className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-full text-slate-900 bg-white hover:bg-slate-100 transition-colors" data-id="element-535" data-mp="prg3za1t9bq1">
              Register as an Artist
            </button>
          </div>

          {/* Featured signed artist */}
          <section aria-labelledby="signed-artist-heading" className="mt-24 max-w-6xl mx-auto" data-id="element-536" data-mp="augybrqirsy7">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-14 items-start" data-id="element-537" data-mp="614dztsvi8b9">
              <div className="lg:col-span-2" data-id="element-538" data-mp="1z9emuui6504">
                <div className="rounded-3xl overflow-hidden border border-green-500/40" data-id="element-539" data-mp="3t8g6lvcy0u6e">
                  <img src="https://cdn.magicpatterns.com/uploads/vcnsXBbGS4zPtRc55VDBKi/Honorable_Music_-Brand_Image_1.png" alt="Honorable Music, Soca artist from Saint Lucia" className="w-full h-auto" data-id="element-540" data-mp="3o93iz8e8zj2r" />
                </div>
              </div>

              <div className="lg:col-span-3" data-id="element-541" data-mp="1s4e22hjoka1q">
                <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-400 text-black text-sm font-bold mb-5" data-id="element-542" data-mp="1s79x9y458kmh">
                  <Star className="w-4 h-4" fill="currentColor" aria-hidden="true" data-id="element-543" data-mp="1ieufb0sujw1l" />
                  Our First Signed Artist
                </span>

                <h2 id="signed-artist-heading" className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight" data-id="element-544" data-mp="14hxo2y8tgck6">
                  <span className="text-green-400" data-id="element-545" data-mp="uj8avirv7ga9">Honorable</span> Music
                </h2>

                <p className="text-lg text-slate-300 leading-relaxed mb-8" data-id="element-546" data-mp="zha0kmjsqdup">
                  The artist who started it all for TwiceBourne Records — a
                  rising Soca voice out of Saint Lucia bringing infectious
                  rhythms and unforgettable performances to every stage.
                </p>

                <SongList data-id="element-547" data-mp="i5cz2bv98zd9" />

                <a href="/honorable-music" className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-green-400 hover:bg-green-300 text-black font-bold transition-colors duration-150" data-id="element-548" data-mp="d8milnfjg1rb">
                  Visit Artist Page
                  <ArrowRight className="w-5 h-5" aria-hidden="true" data-id="element-549" data-mp="10xxdioa7j1xj" />
                </a>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer data-id="element-550" data-mp="wyepvkr04cr0" />
    </div>;
}